import { render } from "./mixupload.vue?vue&type=template&id=2cbdb6a4"
import script from "./mixupload.vue?vue&type=script&lang=js"
export * from "./mixupload.vue?vue&type=script&lang=js"

import "./mixupload.vue?vue&type=style&index=0&id=2cbdb6a4&lang=css"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__